import { Component, OnInit, Output,Input ,EventEmitter } from '@angular/core';
import { MatTableDataSource ,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS} from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router,ActivatedRoute } from '@angular/router';
import Swal from "sweetalert2";
import { DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../../models/messages';
import { DesembolsoService } from '../../../../services/tesoreria/desembolso/desembolso.service';
import { Operacion } from 'app/models/Operacion';
import { LoginService } from 'app/services/login/login.service';

export const MY_FORMATS = {
    parse: {
      dateInput: "DD-MM-YYYY"
    },
    display: {
      dateInput: "DD-MM-YYYY",
      monthYearLabel: "MMM YYYY",
      dateA11yLabel: "DD-MM-YYYY",
      monthYearA11yLabel: "MMMM YYYY"
    }
};

declare var $: any;
@Component({
    selector: 'app-generar-desembolso',
    templateUrl: './generar-desembolso.component.html',
    styleUrls: ['./generar-desembolso.component.scss'],
    providers: [MessagesTitles,MessagesGeneral,MessagesDates,
      DatePipe,
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE]
      },
  
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ]
})

export class GenerarDesembolsoComponent implements OnInit{

    idEmpresa : number = 0;
    operacion : Operacion;
    user:any;
    Simboloi:string;
    dataDesembolso : any = [];
    datares:any = [];
    cont:number = 0;
    
    loading:boolean=false;
    @Input() DesembolsoGeneral:any = [];
    @Output() cerrarGenerarDesembolso: EventEmitter<boolean>;

    formularioGenerarDesembolso : FormGroup;
    formularioCrearDesembolso : FormGroup;


    dataSource :any;
    dataSourceConDetalle :any;
    constructor(private routerActive:ActivatedRoute,
                private router:Router, 
                private desembolsoService:DesembolsoService,
                private msgTitulos : MessagesTitles,
                private loginService:LoginService
      ){
        
        this.user = JSON.parse(sessionStorage.getItem('UserActive'));
        this.routerActive.params.subscribe( params => {
    
        this.cerrarGenerarDesembolso = new EventEmitter();

        
        this.idEmpresa = params['id']; 
    })
      this.formularioGenerarDesembolso = new FormGroup({
        "idSolicitudDesembolso":new FormControl('', Validators.required),
        "idUser":new FormControl(''),
        "Proveedor": new FormControl('',  Validators.required),
        "Adquirente": new FormControl('',  Validators.required),
        "MonedaDescripcion": new FormControl('',  Validators.required),
        "Fecha_Contrato": new FormControl('',  Validators.required),
        "Adelanto":new FormControl('',  Validators.required),
        "TEM":new FormControl('',  Validators.required),
        "Desembolso":new FormControl('',Validators.required)
      
  });

    this.formularioCrearDesembolso = new FormGroup({
      Tipo_de_planilla  :new FormControl(''),
      Moneda : new FormControl(''),
      Importe :new FormControl(''),
      Alta_Usuario : new FormControl(''),
      idSolicitudDesembolso : new FormControl(''),
    });

    }

    ngOnInit(){
      
      this.dataSource = new MatTableDataSource(this.DesembolsoGeneral);
    }

    CerrarPopUp(){
      this.cerrarGenerarDesembolso.emit();
  }
  

  guardarDesembolso(){
    this.loading = true;
    
    let solicitudDes :any = [];
    let montoTotal :number = 0;
    
    for(let array of this.DesembolsoGeneral){
      this.formularioCrearDesembolso.controls['Tipo_de_planilla'].setValue("524");
      this.formularioCrearDesembolso.controls['Moneda'].setValue(array.Moneda);
      this.formularioCrearDesembolso.controls['Alta_Usuario'].setValue(array.Alta_Usuario);
      montoTotal += parseFloat(array.Desembolso_Importe);
      solicitudDes.push(array.idSolicitudDesembolso);
    }
    
    this.formularioCrearDesembolso.controls['Importe'].setValue(montoTotal);
    this.formularioCrearDesembolso.controls['idSolicitudDesembolso'].setValue(solicitudDes);

    Swal.fire({
        title: "Espere",
        text: "Guardando información",
        type: "info",
        allowOutsideClick: false,
        heightAuto: false
    });
    Swal.showLoading();
    console.log(this.formularioCrearDesembolso.getRawValue());
    this.desembolsoService.crearDesembolso(this.formularioCrearDesembolso.getRawValue()).subscribe(
      res=>{
        this.dataDesembolso= res['message'];        
        Swal.fire({
          title: "Success",
          text: "Desembolso registrado correctamente",
          type: "success",
          allowOutsideClick: false,
          heightAuto: false
        }).then(resp => {
          if (resp.value){
            this.loading = false;
            this.showNotification('success','top','right','Se envio correo con pdf adjunto.');
            this.loginService.clickGuard = true; 
            this.router.navigate(["/tesoreria/desembolso/listado"]);
          }
        });
      },err =>  {
          if (err.error.code == 500) {
              err.error.error = "Problemas con el sistema, por favor contactarse con soporte"
          }          
        this.loading = false;
        Swal.fire({
          title: this.msgTitulos.Error_Algo_Salio_Mal,
          text: err.error.error,
          type: "warning",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );
  }
  
  enviarCorreoDesembolso(idDesembolso){
    this.desembolsoService.DownloadPdfPlanillaDesembolso(idDesembolso)                                            
    .subscribe(
        res => { 
          this.loading = false;
          Swal.fire({
            title: "Success",
            text: "Desembolso registrado correctamente",
            type: "success",
            allowOutsideClick: false
          }).then(resp => {
            if (resp.value){
              this.loginService.clickGuard = true; 
              this.router.navigate(["/tesoreria/desembolso/listado"]);
            }
          });      
          this.showNotification('success','top','right','Se envio correo con pdf adjunto.');
        },err => {
          this.loading = false;
            if (err.error.code == 500) {
                err.error.error = "Problemas con el sistema, por favor contactarse con soporte"
            }            
          let error = "";
          error = err.error.error;
          this.showNotification('warning','top','right','No se pudo enviar pdf. \n Error: ' + error);
        }
    );
  }


  showNotification(type,from,align,message){
    
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }
}